import { createIcon } from '@chakra-ui/react';

export const LogoDAF = createIcon({
  displayName: 'DAF Logo',
  viewBox: '0 0 44.041 18',
  path: (
    <path
      id="Path_2176"
      data-name="Path 2176"
      d="M44.041,2.734V.325H32.512V16.439a4.787,4.787,0,0,1-1.668-2.425Q28.919,8.336,27.059,2.643A3.3,3.3,0,0,0,23.519,0c-2.08,0-2.681,1.248-3.2,2.721-1.033,2.975-1.938,6-3.039,8.948-.32.86-1.008,1.234-1.571,1.828-.3.287-.876.456-.8.112.134-.638.327-1.261.5-1.893C17.079,5.76,14.207.924,8.3.186A73.4,73.4,0,0,0,0,.146V18a69.474,69.474,0,0,0,15.143-1.511c.673-.236,1.122-.248,1.02.657a13.349,13.349,0,0,0,2.972.16,5.216,5.216,0,0,0,.4-1.2c.945-3.2,3.841-4.01,6.116-6.033,1,2.777,1.857,5.152,2.676,7.425h7.8V10.413l7.085-.334V7.47H36.447V2.734ZM11.277,11.547c-1.358,3.633-4.727,3.614-8.1,3.488V2.925A6.464,6.464,0,0,1,10.4,4.333C12.373,6.513,12.161,9.182,11.277,11.547Zm9.69-1.256c.688-2.672,1.287-5.016,1.962-7.641C26.009,6.433,24.57,8.988,20.967,10.291Z"
      transform="translate(0 0)"
      fill="currentColor"
    />
  ),
});
